// extracted by mini-css-extract-plugin
module.exports = {"container":"Pop_container__1AtrC","tooltip":"Pop_tooltip___YC2n"};